import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilters } from '../../redux/inboxSlice';
import InboxPage from '../inbox/InboxPage';

// Facebook Messenger DMs flow through the same generic Conversation/InboxMessage
// models as Instagram/WhatsApp (channel: 'messenger') — no separate messaging UI
// needed, just pre-filter the existing unified inbox to this channel.
export default function FacebookMessagesTab() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFilters({ channel: 'messenger' }));
  }, [dispatch]);

  return <InboxPage />;
}
